import React, { useCallback } from 'react';
import { BroadcastEventType } from '@cotera/api';
import { EventsProvider } from '@cotera/client/app/components/events-provider';
import { ModelScopeFactory } from '@cotera/client/v0/actions/framework';
import { useTenantedClient, useWhoami } from '@cotera/client/app/stores/org';
import { useWatchablesFactory } from '@cotera/client/app/v1/watchables/watchables-factory-context';
import { SlackBotConnector } from '../components/tool-connections/slack-bot-connector';
import { TeamsBotConnector } from '../components/tool-connections/teams-bot-connector';
import { LinearBotConnector } from '../components/tool-connections/linear-bot-connector';
import { SlackBotSettingsModel } from './slack-bot-settings.model';
import { TeamsBotSettingsModel } from './teams-bot-settings.model';
import { LinearBotSettingsModel } from './linear-bot-settings.model';

const BotsViewContent: React.FC = () => {
  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-sm font-medium">Chat Bots</h3>
        <p className="mt-0.5 text-xs text-muted-foreground">
          Install Coco into Slack, Teams, and Linear so your team can chat from
          DMs, mentions, and issue delegation.
        </p>
      </div>

      <SlackBotConnector />
      <TeamsBotConnector />
      <LinearBotConnector />
    </div>
  );
};

export const BotsView: React.FC = () => {
  const client = useTenantedClient();
  const orgId = useWhoami((s) => s.org.id);
  const watchablesFactory = useWatchablesFactory();

  const createModels = useCallback(
    () => [
      new SlackBotSettingsModel({ orgId, client, watchablesFactory }),
      new TeamsBotSettingsModel({ orgId, client, watchablesFactory }),
      new LinearBotSettingsModel({ orgId, client, watchablesFactory }),
    ],
    [client, orgId, watchablesFactory]
  );

  return (
    <EventsProvider eventTypes={[BroadcastEventType.ChatBotConfigUpdated]}>
      <ModelScopeFactory
        createModels={createModels}
        deps={[client, orgId, watchablesFactory]}
      >
        <BotsViewContent />
      </ModelScopeFactory>
    </EventsProvider>
  );
};
